import React from 'react';
import './index.css'
import TopMenu from "./sections/TopMenu";
import BannerCarousel from "./sections/BannerCarousel";
import Services from "./sections/Services";
import About from "./sections/About";
import Footer from "./sections/Footer";


export default function App() {

  return (
      <div className="page-grid">

          <TopMenu />

          <BannerCarousel />

          <div className="services-header">ACEPIM SERVICES</div>

          <div className="services-subheader">Acepim provides variety of data services making your company a strong player in ecommerce</div>

          <Services />

          <About />

          <Footer />

      </div>

  );
}
